import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../../../shared/http.service';
import { FormsService } from '../../../shared/forms.service';
import { ActivatedRoute, Params } from '@angular/router';
import { BannerResponse, BannerRequest } from '@builtbybros/al-model';
import { AlertService } from '../../../shared/alert.service';


@Component({
  selector: 'app-banner-form',
  templateUrl: './banner-form.component.html',
  styleUrls: ['./banner-form.component.scss']
})
export class BannerFormComponent implements OnInit {
  bannerId;
  bannerForm: FormGroup;
  bannerUrl = '/Banner/';
  bannerReady = false;
  role = 2;

  @ViewChild('fileInput') fileInput: ElementRef;

  constructor(private route: ActivatedRoute,
              private formsService: FormsService,
              private httpService: HttpService,
              private alertService: AlertService,
              private fb: FormBuilder) {
    this.createFormGroup();
  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      if (params['bannerId']) {
        this.bannerId = +params['bannerId'];
        const responseExpected = new BannerResponse.Banner();

        this.httpService.get(this.bannerUrl, this.bannerId, responseExpected)
          .subscribe(
            bannerResponse => {
              this.bannerForm.patchValue(bannerResponse);
              this.role = bannerResponse.role;
              this.bannerReady = true;
            });
      } else {
        this.bannerReady = true;
      }
    });
  }

  submitForm() {
    if (this.formsService.validateFormAndUpdateErrors(this.bannerForm)) {
      const expectedResponse = new BannerResponse.Banner();
      if (this.bannerId) {
        const banner = new BannerRequest.Update();
        banner.parse(this.bannerForm.value);
        banner.role = this.role;
        this.httpService.patch(this.bannerId, this.bannerUrl, banner, expectedResponse)
          .subscribe(
            createResponse => {
              this.alertService.success('Banner actualizado correctamente');
            },
            error => {
              this.alertService.error(error);
            }
          );
      } else {
        const banner = new BannerRequest.Create();
        banner.parse(this.bannerForm.value);
        banner.ranking = 100; // ranking by default
        banner.role = this.role;
        this.httpService.post(this.bannerUrl, banner, expectedResponse)
          .subscribe(
            createResponse => {
              this.alertService.success('Banner creado correctamente');
            },
            error => {
              this.alertService.error(error);
            }
          );
      }
    }
  }

  onFileChange(event) {
    let reader = new FileReader();
    if(event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.bannerForm.get('imgBannerBase64').setValue(reader.result);
      };
    }
  }

  setRole(event) {
    this.role = event;
  }

  private createFormGroup() {
    this.bannerForm = this.fb.group({
      'name': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
      'destinyURL': [
        '/',
        Validators.compose([
          Validators.required
        ])
      ],
      'imgBannerBase64': [
        null
      ],
      'role': [
        2,
        null
      ],
      'active': [
        true,
        null
      ]
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/banner/shared/banner-form/banner-form.component.ts